import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MarkupsLIstData } from '../utils/TypesMarkupsList';
// import ComponentAddMarkupsDialog from './ComponentAddMarkupsDialog';
import DataTable from '../../../../Common/DataTable';
import ComponentEditMarkupsDialog from './ComponentEditMarkupsDialog';
import { RootState } from '../../../../redux/rootState';
import { setLoader } from '../../../../redux/loaderSlice';
// import ComponentDeleteModal from '../../../../Common/DeleteModal/ComponentDeleteModal';
import { defaultPageSize } from '../../../../utils/Constant';
import { getSiteMarkupStart } from '../../Markups/Redux/sliceMarkups';

function ComponentMarkupsTable() {
  const dispatch = useDispatch();

  const { SiteMarkup, isLoading } = useSelector((state: RootState) => state.SystemMarkupReducer);
  // const { showDeleteIcon } = useSelector((state: RootState) => state.masterDataReducer);

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');

  const handleData = () => {
    const params = {
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
    };
    dispatch(getSiteMarkupStart(params));
  };
  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortCol, sortDir]);

  // const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [rowwId, setRowwId] = useState('');
  // const [showDeleteModal, setShowDeleteModal] = useState(false);
  // const [selectedMarupsId, setSelectedMarkupsId] = useState<string>('');

  const handleAction = (id: string) => {
    setOpenEdit(true);
    setRowwId(id);
  };

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const TableColumns = useMemo(
    () => [
      // { key: 'sn', label: 'SN' },
      { key: 'action', label: 'Action' },
      { key: 'Description', label: 'Description' },
      { key: 'Percentage', label: 'Percentage' },
      // { key: 'IsAllowMarkUp', label: 'Allow min to be marked up' },

    ],
    [],
  );
  const tableData: MarkupsLIstData[] = useMemo(() => SiteMarkup?.Data?.map((item, index) => {
    const transformedDataItem = {
      sn: index,
      action: 'edit',
      // action: showDeleteIcon ? 'edit&delete' : 'edit',
      Description: item.Description,
      Percentage: item.Percentage,
      // IsAllowMarkUp: item.IsAllowMarkUp,

      id: String(item?.Id),
    };
    return transformedDataItem;
  }), [SiteMarkup]);

  return (
    <>
      <DataTable<MarkupsLIstData>
        // handleButtonClick={() => setOpen(true)}
        data={tableData}
        columns={TableColumns}
        totalRecords={SiteMarkup?.TotalRecords}
        // checkBoxColumns={['IsAllowMarkUp']}
        // buttonText="Add Markup"
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        searchQuery={searchQuery}
        setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
        sortCol={sortCol}
        setSortCol={(e) => { setSortCol(e); setPage(1); }}
        sortDir={sortDir}
        setSortDir={(e) => { setSortDir(e); setPage(1); }}
        handleData={handleData}
        handleEdit={handleAction}
        // handleDelete={handleDelete}
        handleDataFromComponent
      />
      {/* <ComponentAddMarkupsDialog show={open} setOpenFrom={() => setOpen(false)} handleData={handleData} /> */}
      <ComponentEditMarkupsDialog show={openEdit} setOpenFrom={() => setOpenEdit(false)} rowId={rowwId} handleData={handleData} />
      {/* <ComponentDeleteModal
        show={showDeleteModal}
        setOpenFrom={() => setShowDeleteModal(false)}
        handleDelete={handelDeleteModal}
      /> */}
    </>
  );
}

export default ComponentMarkupsTable;
